<template lang="pug">
    v-autocomplete(dense 
        v-model="dataTreasury" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        :item-text="text" 
        item-value="treasuryId" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectTreasury",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required"
    ],
    data() {
        return {
            dataTreasury: {},
            listData: []
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    created() {
        this.$session.userDetail().then(item => {
            this.listData = item.corporate.corporateGroup.instances || [];
            this.dataTreasury = this.dataTreasury ? this.listData[0] : null;
        });
    },
    methods: {
        text: item => "(" + item.instanceId + ") " + item.treasuryId + " - " + item.treasuryName,
        doInit(values){
            this.dataTreasury = values ? values : null;
        },
        onSelect() {
            this.$emit("input", this.dataTreasury);
            this.$emit("select", this.dataTreasury);
            this.$emit("treasury", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataTreasury === element.treasuryId) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>